import commonMessages from "constant/commonMessage";
import { toastMessage } from "./toastMessageHelper";
import { regexValue } from "../constant/constantValue";
import { profileImageHandler } from "./commonHelper";

const { IMAGE_FORMAT, DOC_FORMAT, AUDIO_FORMAT, VIDEO_FORMAT, PDF_FORMAT } =
  commonMessages;

export const mediaRegexHandler = (mediaType) => {
  const regexMap = {
    image: { regexValidator: regexValue.IMAGE_FILE_REGEX, error: IMAGE_FORMAT },
    document: {
      regexValidator: regexValue.DOCUMENT_FILE_REGEX,
      error: DOC_FORMAT,
    },
    audio: { regexValidator: regexValue.AUDIO_FILE_REGEX, error: AUDIO_FORMAT },
    video: { regexValidator: regexValue.VIDEO_FILE_REGEX, error: VIDEO_FORMAT },
    pdf: { regexValidator: regexValue.PDF_FILE_REGEX, error: PDF_FORMAT },
  };

  // Validate if mediaType exists in the regexMap
  if (!regexMap[mediaType]) {
    return {
      regexValidator: null,
      error: "Invalid file format type",
    };
  }

  return regexMap[mediaType];
};

const resetFile = (e) => {
  e.target.value = "";
};

export const mediaFileHandler = (e, mediaType) => {
  e.preventDefault();
  const file = e.target.files?.[0];
  // Check if no file is selected
  if (!file) {
    resetFile(e);
    return;
  }
  const { regexValidator, error } = mediaRegexHandler(mediaType);
  if (regexValidator && regexValidator.test(file.name)) {
    return file;
  } else {
    resetFile(e);
    toastMessage(error, "error", "fileFormat");
  }
};

export const imageFileHandler = (e, setFile) => {
  const imageFile = mediaFileHandler(e, "image");
  setFile(imageFile);
};

export const showImageHolder = (image, url, otherFile = "") => {
  const imageUrl = image && image?.name && URL.createObjectURL(image);
  return imageUrl || url || otherFile;
};

export const showImageWithGender = (
  image,
  url,
  gender = "",
  otherFile = ""
) => {
  return showImageHolder(image, url, profileImageHandler(gender) || otherFile);
};
